import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { parse, stringify } from 'query-string'
import { useHistory } from 'react-router'

import { dockActions } from '../../../store/dock'

export function useHandleDockOpeningQueryStringParam(): void {
  const dispatch = useDispatch()
  const history = useHistory()

  const { search, pathname } = history?.location || {}

  useEffect(() => {
    const queryParams = parse(search) || {}
    const { openCommentsDock: canOpenCommentsDock, ...restQueryParams } = queryParams

    if (!canOpenCommentsDock) {
      return
    }

    dispatch(dockActions.openDock('COMMENTS'))

    const pathname = window.location.pathname
    const redirectLocation = `${pathname}?${stringify(restQueryParams)}`
    history.push(redirectLocation)
  }, [search, pathname, dispatch])
}
